// Datos demo para probar Construcción de punta a punta: un parque Solar FV en
// NTP con Área Construcción + CECO, WBS, avances, hitos, OC imputadas,
// despachos a obra, un contratista con estados de pago, partes diarios y HSE.
// Las fechas son relativas a "hoy" para que el escenario siempre esté vigente.
import { toIsoDate } from './evm';

export const DEMO_PARK_ID = 'park-demo-valle-sur';
const AREA_CONST = 'area-demo-valle-const';
const AREA_OPER = 'area-demo-valle-oper';
const CC_CONST = 'cc-demo-valle-const';
const CC_OPER = 'cc-demo-valle-oper';
const LOC_OBRA = 'loc-demo-valle-obra';

// Usuarios de seedZero.js
const PM_ID = 'usr-2';
const TECH_ID = 'usr-6';
const CONTROLLER_ID = 'usr-7';
const CONTRACT_MANAGER_ID = 'usr-11';
const AREA_MANAGER_ID = 'usr-3';

export const buildConstructionDemo = (today = new Date()) => {
  // Día 0 = NTP / inicio de obras, hace 120 días.
  const day = (offset) => {
    const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    date.setDate(date.getDate() - 120 + offset);
    return toIsoDate(date);
  };
  const stamp = (offset) => `${day(offset)} 18:00`;

  const base = {
    label: 'Demo Construcción',
    parks: [
      {
        id: DEMO_PARK_ID,
        name: 'Parque Solar Valle Sur',
        code: 'PK-VSUR',
        managerId: PM_ID,
        packages: [
          { id: 'pkg-vsur-civ', code: 'WBS-CIV', name: 'Obras civiles' },
          { id: 'pkg-vsur-est', code: 'WBS-EST', name: 'Montaje estructuras' },
          { id: 'pkg-vsur-mod', code: 'WBS-MOD', name: 'Montaje módulos' },
          { id: 'pkg-vsur-elec', code: 'WBS-ELEC', name: 'Eléctrico BT/MT' },
          { id: 'pkg-vsur-pru', code: 'WBS-PRU', name: 'Pruebas y puesta en marcha' }
        ],
        areas: [
          { id: AREA_CONST, name: 'Construcción', costCenterId: CC_CONST, areaManagerId: AREA_MANAGER_ID },
          { id: AREA_OPER, name: 'Operación', costCenterId: CC_OPER, areaManagerId: null }
        ],
        team: {
          projectManagerId: PM_ID,
          administrators: [],
          controllerId: CONTROLLER_ID,
          fieldTeam: [TECH_ID, 'usr-9'],
          areaManagers: [AREA_MANAGER_ID]
        }
      }
    ],
    costCenters: [
      { id: CC_CONST, code: 'CC-VSUR-CON', name: 'Construcción Valle Sur', parkId: DEMO_PARK_ID, areaId: AREA_CONST, description: 'EPC construcción' },
      { id: CC_OPER, code: 'CC-VSUR-OPE', name: 'Operación Valle Sur', parkId: DEMO_PARK_ID, areaId: AREA_OPER, description: 'O&M' }
    ],
    categories: [
      { id: 'cat-demo-equipos', name: 'Equipos Energía', type: 'material', budgetCategory: 'materiales_principales' },
      { id: 'cat-demo-subcontratos', name: 'Subcontratos de obra', type: 'servicio', budgetCategory: 'subcontratos' }
    ],
    projectBudgets: [
      {
        id: `budget-${DEMO_PARK_ID}`,
        parkId: DEMO_PARK_ID,
        currency: 'USD',
        total: 34000000,
        allocations: [
          { id: 'alloc-vsur-mat', category: 'materiales_principales', amount: 21000000, committed: 0, invoiced: 0 },
          { id: 'alloc-vsur-sub', category: 'subcontratos', amount: 13000000, committed: 0, invoiced: 0 }
        ]
      }
    ],
    renewableProjects: [
      {
        id: 'ren-demo-valle-sur',
        parkId: DEMO_PARK_ID,
        name: 'Parque Solar Valle Sur',
        technology: 'Solar FV',
        region: 'Maule',
        commune: 'San Clemente',
        mw: 50,
        stage: 'ntp',
        rtbProgress: 100,
        responsibleId: PM_ID,
        approval: { projectManager: true, purchasingManager: true },
        coordinates: { lat: -35.55, lng: -71.49 }
      }
    ],
    suppliers: [
      { id: 'sup-demo-movitierra', name: 'Movitierra SpA', rut: '76.111.222-3', country: 'Chile', type: 'nacional', status: 'Approved', complianceScore: 88, riskLevel: 'Bajo', categories: ['Obras civiles'] },
      { id: 'sup-demo-hincados', name: 'Hincados del Sur Ltda.', rut: '76.333.444-5', country: 'Chile', type: 'nacional', status: 'Approved', complianceScore: 82, riskLevel: 'Medio', categories: ['Fundaciones'] },
      { id: 'sup-demo-tracker', name: 'SolarTrack Chile SpA', rut: '76.555.666-7', country: 'Chile', type: 'internacional', status: 'Approved', complianceScore: 91, riskLevel: 'Bajo', categories: ['Estructuras'] },
      { id: 'sup-demo-montajes', name: 'Montajes Electromecánicos Andes SpA', rut: '76.777.888-9', country: 'Chile', type: 'nacional', status: 'Approved', complianceScore: 86, riskLevel: 'Bajo', categories: ['Montaje electromecánico'] }
    ],
    locations: [
      { id: LOC_OBRA, name: 'Obra Valle Sur (patio de materiales)', code: 'OB-VSUR', address: 'San Clemente, Maule', type: 'proyecto' }
    ],
    inventory: [
      { id: 'item-demo-trk', sku: 'EST-TRK-01', description: 'Tracker 1 eje (set completo)', categoryId: 'cat-demo-equipos', category: 'Equipos Energía', unit: 'set', unitValue: 2800000, safetyStock: 0, primaryParkId: DEMO_PARK_ID, locations: [{ locationId: LOC_OBRA, quantity: 120 }] },
      { id: 'item-demo-mod', sku: 'MOD-FV-550', description: 'Módulo FV bifacial 550 W', categoryId: 'cat-demo-equipos', category: 'Equipos Energía', unit: 'unidad', unitValue: 95000, safetyStock: 0, primaryParkId: DEMO_PARK_ID, locations: [{ locationId: LOC_OBRA, quantity: 1500 }] },
      { id: 'item-demo-cab', sku: 'CAB-BT-6', description: 'Cable solar BT 6 mm²', categoryId: 'cat-demo-equipos', category: 'Equipos Energía', unit: 'm', unitValue: 900, safetyStock: 0, primaryParkId: DEMO_PARK_ID, locations: [{ locationId: LOC_OBRA, quantity: 0 }] }
    ],
    purchaseOrders: [
      { id: 'OC-DEMO-0101', supplierId: 'sup-demo-movitierra', supplierName: 'Movitierra SpA', type: 'nacional', status: 'recibida', createdDate: day(5), currency: 'USD', totalValue: 2300000, invoicedValue: 2300000, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: 'pkg-vsur-civ', items: [], notes: 'Movimiento de tierras y caminos interiores' },
      { id: 'OC-DEMO-0102', supplierId: 'sup-demo-hincados', supplierName: 'Hincados del Sur Ltda.', type: 'nacional', status: 'recibida', createdDate: day(25), currency: 'USD', totalValue: 3000000, invoicedValue: 3000000, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: 'pkg-vsur-civ', items: [], notes: 'Hincado de pilotes' },
      { id: 'OC-DEMO-0103', supplierId: 'sup-demo-tracker', supplierName: 'SolarTrack Chile SpA', type: 'internacional', status: 'recibida', createdDate: day(40), currency: 'USD', totalValue: 1600000, invoicedValue: 1600000, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: 'pkg-vsur-est', items: [], notes: 'Trackers lote 1' },
      { id: 'OC-DEMO-0104', supplierId: 'sup-demo-tracker', supplierName: 'SolarTrack Chile SpA', type: 'internacional', status: 'aprobada', createdDate: day(80), currency: 'USD', totalValue: 2900000, invoicedValue: 0, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: 'pkg-vsur-est', items: [], notes: 'Trackers lote 2 (comprometido)' },
      { id: 'OC-DEMO-0105', supplierId: 'sup-demo-movitierra', supplierName: 'Movitierra SpA', type: 'nacional', status: 'recibida', createdDate: day(2), currency: 'CLP', totalValue: 237500000, invoicedValue: 237500000, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: null, items: [], notes: 'Instalación de faenas (sin paquete WBS)' },
      { id: 'OC-DEMO-0106', supplierId: 'sup-demo-montajes', supplierName: 'Montajes Electromecánicos Andes SpA', type: 'nacional', status: 'aprobada', createdDate: day(60), currency: 'USD', totalValue: 3000000, invoicedValue: 0, parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST, packageId: 'pkg-vsur-est', items: [], notes: 'Subcontrato montaje trackers (pagado vía estados de pago)' }
    ],
    shipments: [
      {
        id: 'SHP-DEMO-01', reference: 'DESP-VSUR-01', status: 'recepcionado', createdAt: day(70), receivedAt: day(72),
        requestedBy: PM_ID, approvedBy: PM_ID, originLocationId: 'loc-1', destinationLocationId: LOC_OBRA,
        parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST,
        items: [{ sku: 'EST-TRK-01', quantity: 500 }, { sku: 'MOD-FV-550', quantity: 3000 }, { sku: 'CAB-BT-6', quantity: 6000 }],
        documents: [], history: []
      },
      {
        id: 'SHP-DEMO-02', reference: 'DESP-VSUR-02', status: 'en tránsito', createdAt: day(118),
        requestedBy: PM_ID, approvedBy: PM_ID, originLocationId: 'loc-1', destinationLocationId: LOC_OBRA,
        parkId: DEMO_PARK_ID, areaId: AREA_CONST, costCenterId: CC_CONST,
        items: [{ sku: 'MOD-FV-550', quantity: 5000 }], documents: [], history: []
      }
    ]
  };

  const item = (id, parentId, code, name, extra = {}) => ({ id, parkId: DEMO_PARK_ID, parentId, code, name, predecessors: [], responsible: '', status: 'auto', ...extra });
  const wbsItems = [
    item('wbs-vsur-1', null, '1', 'Obras civiles'),
    item('wbs-vsur-1-1', 'wbs-vsur-1', '1.1', 'Movimiento de tierras y caminos', { weight: 8, bac: 2400000, baselineStart: day(0), baselineEnd: day(60), actualStart: day(2), actualEnd: day(62), packageId: 'pkg-vsur-civ', responsible: 'Movitierra SpA' }),
    item('wbs-vsur-1-2', 'wbs-vsur-1', '1.2', 'Fundaciones (hincado de pilotes)', { weight: 10, bac: 3200000, baselineStart: day(30), baselineEnd: day(110), actualStart: day(35), packageId: 'pkg-vsur-civ', predecessors: ['wbs-vsur-1-1'], responsible: 'Hincados del Sur Ltda.' }),
    item('wbs-vsur-1-3', 'wbs-vsur-1', '1.3', 'Cerco perimetral y drenajes', { weight: 4, bac: 1000000, baselineStart: day(20), baselineEnd: day(80), actualStart: day(25), packageId: 'pkg-vsur-civ', responsible: 'Movitierra SpA' }),
    item('wbs-vsur-2', null, '2', 'Montaje estructuras'),
    item('wbs-vsur-2-1', 'wbs-vsur-2', '2.1', 'Montaje de trackers', { weight: 14, bac: 4800000, baselineStart: day(70), baselineEnd: day(170), actualStart: day(78), packageId: 'pkg-vsur-est', predecessors: ['wbs-vsur-1-2'], responsible: 'Montajes Electromecánicos Andes SpA', materials: [{ sku: 'EST-TRK-01', plannedQty: 1200 }] }),
    item('wbs-vsur-3', null, '3', 'Montaje módulos'),
    item('wbs-vsur-3-1', 'wbs-vsur-3', '3.1', 'Instalación de módulos FV', { weight: 20, bac: 9600000, baselineStart: day(120), baselineEnd: day(230), packageId: 'pkg-vsur-mod', predecessors: ['wbs-vsur-2-1'], responsible: 'Montajes Electromecánicos Andes SpA', materials: [{ sku: 'MOD-FV-550', plannedQty: 90900 }] }),
    item('wbs-vsur-4', null, '4', 'Eléctrico BT/MT'),
    item('wbs-vsur-4-1', 'wbs-vsur-4', '4.1', 'Canalizaciones y cableado BT', { weight: 12, bac: 3600000, baselineStart: day(140), baselineEnd: day(240), packageId: 'pkg-vsur-elec', responsible: 'Montajes Electromecánicos Andes SpA', materials: [{ sku: 'CAB-BT-6', plannedQty: 180000 }] }),
    item('wbs-vsur-4-2', 'wbs-vsur-4', '4.2', 'Inversores y centros de transformación', { weight: 10, bac: 4200000, baselineStart: day(180), baselineEnd: day(260), packageId: 'pkg-vsur-elec' }),
    item('wbs-vsur-4-3', 'wbs-vsur-4', '4.3', 'Línea MT y subestación', { weight: 12, bac: 2800000, baselineStart: day(200), baselineEnd: day(280), packageId: 'pkg-vsur-elec' }),
    item('wbs-vsur-5', null, '5', 'Pruebas y puesta en marcha'),
    item('wbs-vsur-5-1', 'wbs-vsur-5', '5.1', 'Pruebas en frío y comisionado', { weight: 10, bac: 400000, baselineStart: day(270), baselineEnd: day(300), packageId: 'pkg-vsur-pru', predecessors: ['wbs-vsur-4-2', 'wbs-vsur-4-3'] })
  ];

  let logCounter = 0;
  const log = (wbsItemId, offset, progress, status = 'aprobado', userId = TECH_ID, note = '') => ({
    id: `prog-vsur-${(logCounter += 1)}`,
    parkId: DEMO_PARK_ID,
    wbsItemId,
    date: day(offset),
    progress,
    note,
    userId,
    status,
    approvedBy: status === 'aprobado' ? PM_ID : null,
    createdAt: stamp(offset)
  });
  const progressLogs = [
    log('wbs-vsur-1-1', 20, 30), log('wbs-vsur-1-1', 40, 70), log('wbs-vsur-1-1', 62, 100, 'aprobado', TECH_ID, 'Caminos interiores terminados'),
    log('wbs-vsur-1-2', 50, 20), log('wbs-vsur-1-2', 80, 55), log('wbs-vsur-1-2', 105, 75), log('wbs-vsur-1-2', 118, 85, 'aprobado', TECH_ID, 'Bloques 1 a 6 hincados'),
    log('wbs-vsur-1-3', 40, 40), log('wbs-vsur-1-3', 70, 80), log('wbs-vsur-1-3', 110, 90),
    log('wbs-vsur-2-1', 90, 10), log('wbs-vsur-2-1', 110, 25), log('wbs-vsur-2-1', 118, 35, 'aprobado', TECH_ID, 'Trackers bloques 1-2'),
    log('wbs-vsur-3-1', 119, 2, 'pendiente', TECH_ID, 'Primeros strings de prueba en bloque 1')
  ];

  const milestones = [
    { id: 'ms-vsur-1', parkId: DEMO_PARK_ID, name: 'Inicio de obras (NTP)', targetDate: day(0), completedDate: day(0), wbsItemId: null },
    { id: 'ms-vsur-2', parkId: DEMO_PARK_ID, name: 'Término obras civiles', targetDate: day(110), completedDate: null, wbsItemId: 'wbs-vsur-1' },
    { id: 'ms-vsur-3', parkId: DEMO_PARK_ID, name: 'Inicio montaje de módulos', targetDate: day(125), completedDate: null, wbsItemId: 'wbs-vsur-3-1' },
    { id: 'ms-vsur-4', parkId: DEMO_PARK_ID, name: 'Energización / COD', targetDate: day(290), completedDate: null, wbsItemId: 'wbs-vsur-5-1' }
  ];

  const contractors = [
    {
      id: 'ctr-vsur-1',
      parkId: DEMO_PARK_ID,
      supplierId: 'sup-demo-montajes',
      name: 'Montajes Electromecánicos Andes SpA',
      scope: 'Montaje de trackers (mano de obra y equipos)',
      contractAmount: 3000000,
      retentionPct: 5,
      wbsItemIds: ['wbs-vsur-2-1'],
      purchaseOrderId: 'OC-DEMO-0106',
      startDate: day(75),
      endDate: day(175),
      status: 'vigente',
      createdBy: CONTRACT_MANAGER_ID
    }
  ];

  const paymentStatements = [
    {
      id: 'ep-vsur-1', parkId: DEMO_PARK_ID, contractorId: 'ctr-vsur-1', number: 1, periodEnd: day(110),
      progressPct: 25, previousPct: 0, deltaPct: 25, grossAmount: 750000, retention: 37500, netAmount: 712500,
      status: 'aprobado', createdBy: CONTRACT_MANAGER_ID,
      history: [
        { status: 'pendiente_pm', userId: CONTRACT_MANAGER_ID, at: stamp(111), note: 'EP 1 emitido' },
        { status: 'pendiente_director', userId: PM_ID, at: stamp(112), note: 'Avance verificado en terreno' },
        { status: 'aprobado', userId: 'usr-4', at: stamp(113), note: '' }
      ]
    },
    {
      id: 'ep-vsur-2', parkId: DEMO_PARK_ID, contractorId: 'ctr-vsur-1', number: 2, periodEnd: day(118),
      progressPct: 35, previousPct: 25, deltaPct: 10, grossAmount: 300000, retention: 15000, netAmount: 285000,
      status: 'pendiente_pm', createdBy: CONTRACT_MANAGER_ID,
      history: [{ status: 'pendiente_pm', userId: CONTRACT_MANAGER_ID, at: stamp(119), note: 'EP 2 emitido' }]
    }
  ];

  const dailyLogs = [
    {
      id: 'pd-vsur-1', parkId: DEMO_PARK_ID, date: day(118), weather: 'Despejado', userId: TECH_ID,
      crews: [
        { name: 'Hincados del Sur — cuadrilla A', workers: 10, hours: 9 },
        { name: 'Montajes Andes — trackers', workers: 24, hours: 9 }
      ],
      activities: 'Hincado bloque 6 terminado. Montaje de trackers en bloque 2 (filas 1-18).',
      progressNotes: 'Fundaciones 85%, trackers 35%.',
      equipment: '2 hincadoras, 1 manipulador telescópico, 2 camionetas',
      incidents: 'Sin incidentes de seguridad.',
      attachments: [], createdAt: stamp(118)
    },
    {
      id: 'pd-vsur-2', parkId: DEMO_PARK_ID, date: day(119), weather: 'Viento fuerte', userId: TECH_ID,
      crews: [
        { name: 'Hincados del Sur — cuadrilla A', workers: 10, hours: 6 },
        { name: 'Montajes Andes — trackers', workers: 24, hours: 6 },
        { name: 'Montajes Andes — módulos (prueba)', workers: 8, hours: 6 }
      ],
      activities: 'Se suspende izaje a las 15:00 por viento > 40 km/h. Strings de prueba en bloque 1.',
      progressNotes: 'Inicio de montaje de módulos (prueba).',
      equipment: '1 hincadora, 1 manipulador telescópico',
      incidents: 'Detención preventiva por viento (3 h).',
      attachments: [], createdAt: stamp(119)
    },
    {
      id: 'pd-vsur-3', parkId: DEMO_PARK_ID, date: day(120), weather: 'Nublado', userId: TECH_ID,
      crews: [
        { name: 'Montajes Andes — trackers', workers: 26, hours: 9 },
        { name: 'Montajes Andes — cableado BT', workers: 12, hours: 9 }
      ],
      activities: 'Trackers bloque 3. Tendido de cable BT en zanjas bloque 1.',
      progressNotes: 'Cableado BT iniciado antes de lo programado.',
      equipment: '1 manipulador telescópico, 1 zanjadora',
      incidents: 'Se detecta uso de cable sobre lo recibido en obra: revisar despacho.',
      attachments: [], createdAt: stamp(120)
    }
  ];

  const materialConsumptions = [
    { id: 'cons-vsur-1', parkId: DEMO_PARK_ID, sku: 'EST-TRK-01', quantity: 380, wbsItemId: 'wbs-vsur-2-1', date: day(118), userId: TECH_ID, note: 'Trackers instalados bloques 1-2' },
    { id: 'cons-vsur-2', parkId: DEMO_PARK_ID, sku: 'MOD-FV-550', quantity: 1500, wbsItemId: 'wbs-vsur-3-1', date: day(119), userId: TECH_ID, note: 'Strings de prueba' },
    { id: 'cons-vsur-3', parkId: DEMO_PARK_ID, sku: 'CAB-BT-6', quantity: 9000, wbsItemId: 'wbs-vsur-4-1', date: day(120), userId: TECH_ID, note: 'Tendido zanjas bloque 1' }
  ];

  const inspections = [
    {
      id: 'insp-vsur-1', parkId: DEMO_PARK_ID, wbsItemId: 'wbs-vsur-1-2', type: 'calidad', date: day(100), inspectorId: TECH_ID,
      checklist: [
        { label: 'Verticalidad de pilotes dentro de tolerancia (±1°)', ok: false },
        { label: 'Profundidad de hincado según diseño', ok: true },
        { label: 'Protección anticorrosiva sin daños', ok: true }
      ],
      result: 'observado', notes: 'Bloque 3 con 12 pilotes fuera de tolerancia.'
    },
    {
      id: 'insp-vsur-2', parkId: DEMO_PARK_ID, wbsItemId: 'wbs-vsur-2-1', type: 'hse', date: day(117), inspectorId: TECH_ID,
      checklist: [
        { label: 'Charla de 5 minutos realizada', ok: true },
        { label: 'EPP completo en cuadrillas', ok: true },
        { label: 'Zona de izaje delimitada', ok: true }
      ],
      result: 'conforme', notes: ''
    }
  ];

  const nonConformities = [
    {
      id: 'nc-vsur-1', parkId: DEMO_PARK_ID, wbsItemId: 'wbs-vsur-1-2', inspectionId: 'insp-vsur-1',
      title: 'Pilotes fuera de tolerancia de verticalidad (bloque 3)', description: '12 pilotes con inclinación > 1°. Rehincado o refuerzo según ingeniería.',
      severity: 'media', responsibleName: 'Hincados del Sur Ltda.', openedAt: day(100), dueDate: day(125), status: 'en_tratamiento', closedAt: null, closureNote: ''
    },
    {
      id: 'nc-vsur-2', parkId: DEMO_PARK_ID, wbsItemId: 'wbs-vsur-1-1', inspectionId: null,
      title: 'Compactación insuficiente en camino interior norte', description: 'Ensayo de densidad bajo 95% Proctor.',
      severity: 'baja', responsibleName: 'Movitierra SpA', openedAt: day(45), dueDate: day(60), status: 'cerrada', closedAt: day(58), closureNote: 'Recompactado y ensayo conforme.'
    }
  ];

  return {
    base,
    construction: {
      projects: { [DEMO_PARK_ID]: { currency: 'USD', activatedAt: day(0) } },
      wbsItems,
      progressLogs,
      milestones,
      contractors,
      paymentStatements,
      dailyLogs,
      materialConsumptions,
      inspections,
      nonConformities
    }
  };
};
